const styles = theme => ({
  helpIcon: {
    color: '#202a38',
    width: 18,
    height: 18,
    marginLeft: 3,
    transform: 'rotate(180deg)',
    verticalAlign: 'top',

    '&:hover': {
      cursor: 'pointer'
    }
  },
  helpIconMiddle: {
    verticalAlign: 'middle !important'
  },
  legend: {
    style: 'none',
    float: 'right',
    listStyle: 'none',
    marginTop: 0
  },
  legendItem: {
    display: 'inline-block',
    marginRight: 30,
    '&:last-of-type': {
      marginRight: 0
    }
  },
  bullet: {
    display: 'inline-block',
    width: 8,
    height: 8,
    borderRadius: '50%',
    marginRight: 8
  },
  description: {
    fontSize: 12,
    width: '40%',
    marginLeft: 30,
    marginTop: 30,
    marginBottom: 0,
    color: '#8D8D8D'
  },
  disabled: {
    opacity: 0.5
  },
  disabledIcon: {
    '&:hover': {
      cursor: 'default'
    }
  },
  perfBarChartRoot: {
    minHeight: 150,
    height: 460,
    width: '100%'
  },
})

export default styles;